import { Box, Flex, Heading, Icon, Stack, Text } from '@chakra-ui/react';
import { CheckCircle } from '@phosphor-icons/react';

export default function CompletedPage() {
  return (
    <Flex w="100vw" h="100vh" mt="10%" justify="center" bg="background.secondary" overflow="hidden">
      <Stack gap="24px" align="center" minW={['90vw', '420px']} maxW="90vw">
        <Box transition="all 0.3s ease" _hover={{ transform: 'scale(1.05)' }} color="success.500">
          <Icon as={CheckCircle} w="80px" h="80px" />
        </Box>

        <Stack gap="16px" textAlign="center">
          <Heading as="h1" color="neutrals.900" fontSize="3xl" fontWeight="700">
            Interview Completed!
          </Heading>

          <Text color="neutrals.500" fontSize="16px" maxW="500px" lineHeight="1.6">
            Thank you for completing your interview. Your responses have been submitted
            successfully. We’ll review your answers and follow up with you soon.
          </Text>
        </Stack>

        <Text mt="16px" fontSize="14px" color="neutrals.500" alignSelf="center">
          You can safely close this window
        </Text>
      </Stack>
    </Flex>
  );
}
